import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@stores/auth.store';
import { LoadingState } from '@shared/components';

/** Require an authenticated session; redirect to /login otherwise. */
export function AuthGuard(): React.JSX.Element {
  const isInitialized = useAuthStore((s) => s.isInitialized);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const location = useLocation();

  if (!isInitialized) return <LoadingState fullscreen />;
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <Outlet />;
}
